import WidgetCover from './WidgetCover';

export default WidgetCover;
